import { TrainingInsightFragment } from 'generated/resources/graphql'

export const useTrainingsEmployees = (insights: TrainingInsightFragment) => {
  const trainingHoursAndCost = insights.trainingsEmployees
  const totalUniqueEmployees = trainingHoursAndCost?.totalUniqueEmployees || 0
  const averageEmployeesPerTraining = trainingHoursAndCost?.averageEmployeesPerTraining || 0

  return { totalUniqueEmployees, averageEmployeesPerTraining }
}
